import Axios from "axios";
import S3 from "react-aws-s3";
window.Buffer = window.Buffer || require("buffer").Buffer;

const axios = Axios.create({
  baseURL: process.env.REACT_APP_S3_URL,
});

export const config = {
  bucketName: process.env.REACT_APP_BUCKET_NAME,
  dirName: process.env.REACT_APP_DIR_NAME,
  region: process.env.REACT_APP_REGION,
  accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
};

export const getFileFromS3 = async (url) => {
  let file = await axios.get(url, {
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
    },
  });
  return file.data;
};

export const deleteFile = async (url) => {
  const ReactS3Client = new S3(config);
  return await ReactS3Client.deleteFile(url)
    .then((response) => {
      console.log(response);
    })
    .catch((err) => console.error(err));
};

export const getS3PublicUrl = (path) => {
  if (!path) return "";
  // If it's already an absolute URL, return it
  if (typeof path === "string" && /^(https?:)?\/\//i.test(path)) return path;

  // Use base URL from env if available
  const s3Base = (process.env.REACT_APP_S3_URL || "").replace(/\/$/, "");
  const dirName = process.env.REACT_APP_DIR_NAME || "";

  /**
   * Handle Potential Overlap:
   * We need to avoid ".../prod-data/prod-data/image.png".
   * We strip dirName + "/" from the start of the path IF the s3Base already ends with dirName.
   */
  let cleanPath = path.startsWith("/") ? path.slice(1) : path;

  if (dirName && (cleanPath.startsWith(dirName + "/") || cleanPath === dirName)) {
    if (s3Base.endsWith("/" + dirName) || s3Base.endsWith(dirName)) {
      cleanPath = cleanPath.substring(dirName.length);
      if (cleanPath.startsWith("/")) {
        cleanPath = cleanPath.slice(1);
      }
    }
  }

  const relativePath = cleanPath.startsWith("/") ? cleanPath : `/${cleanPath}`;

  if (s3Base) {
    return `${s3Base}${relativePath}`;
  }

  // Fallback: Dynamic construction from config
  const { bucketName, region } = config;
  if (bucketName && region) {
    return `https://${bucketName}.s3.${region}.amazonaws.com${relativePath}`;
  }

  return relativePath; // Last resort fallback
};

export const deleteAndUploadFile = async (data, filename) => {
  try {
    const ReactS3Client = new S3(config);
    // Attempt to delete existing if possible, but don't fail if it doesn't exist
    try {
      await ReactS3Client.deleteFile(filename);
    } catch (_) { }
    return await uploadFile(data, filename);
  } catch (err) {
    console.error("Delete and Upload Error:", err);
    return null;
  }
};

export const uploadFile = async (file, filename) => {
  const ReactS3Client = new S3(config);

  try {
    const data = await ReactS3Client.uploadFile(file, filename);
    console.log("S3 Upload Success Data:", data);

    /**
     * REVERT RND: In this project, the REACT_APP_S3_URL .env variable
     * already includes the directory prefix (e.g., .../stag-data/).
     * Therefore, we should ONLY return the filename to prevent doubling the path.
     */
    return filename;
  } catch (err) {
    /**
     * SUCCESS RECOVERY: react-aws-s3 v1.5.0 often throws an error on 204 No Content
     * despite a successful upload. We treat this as success.
     */
    const isActuallySuccess = !err ||
      (typeof err === 'object' && Object.keys(err).length === 0) ||
      String(err).includes("204") ||
      (err?.status === 204);

    if (isActuallySuccess) {
      console.log("Treating 204/Empty error as success. Returning filename:", filename);
      return filename;
    }

    console.error("Real S3 Upload error:", err);
    throw err;
  }
};
